import api, { OFFERS_URL } from "./api";

export const createOfferRequest = async (body) => {
  return await api.post(`${OFFERS_URL}`, body);
};

export const updateRequestedOfferStatus = async (offerId, body) => {
  return await api.put(`${OFFERS_URL}/${offerId}`, body);
};

export const fetchOfferDetail = async (offerId) => {
  return await api.get(`${OFFERS_URL}/${offerId}`);
};
